import { hideElementFromAccessibilityTree } from "./GDORSOK6.js";
import { isBackdrop } from "./IXXFVVA2.js";
import { supportsInert } from "./KOVUJERF.js";
import { assignStyle, setAttribute, setProperty } from "./FW6QFGFT.js";
import { walkTreeOutside } from "./5M4ITSXL.js";

// src/dialog/utils/disable-tree-outside.ts
import { contains } from "@ariakit/core/utils/dom";
import { getAllTabbable } from "@ariakit/core/utils/focus";
import { chain, noop } from "@ariakit/core/utils/misc";
function disableElement(element) {
  if (!("style" in element)) return noop;
  if (supportsInert()) {
    return setProperty(element, "inert", true);
  }
  return chain(hideElementFromAccessibilityTree(element), assignStyle(element, {
    pointerEvents: "none",
    userSelect: "none",
    cursor: "default"
  }));
}
function disableTreeOutside() {
  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }
  const cleanups = [];
  const ids = elements.map(el => el == null ? void 0 : el.id);
  if (!supportsInert()) {
    getAllTabbable().forEach(element => {
      if (elements.some(el => el && contains(el, element))) return;
      cleanups.unshift(setAttribute(element, "tabindex", "-1"));
    });
  }
  walkTreeOutside(elements, element => {
    if (isBackdrop(element, ...ids)) return;
    cleanups.unshift(disableElement(element));
  });
  const restoreTreeOutside = () => {
    cleanups.forEach(fn => fn());
  };
  return restoreTreeOutside;
}
export { disableTreeOutside };